import { MicroformFlex } from './MicroformFlex';
import { EckohCheckout } from './EckohCheckout';
import { useQueryParamsContext } from '../context/QueryParamsContext';

/**
 * Renders the appropriate checkout form based on clientType:
 * - clientType === 'MSC' (case-insensitive) -> EckohCheckout (iframe integration)
 * - clientType === 'iOS' or default -> MicroformFlex (Cybersource microform)
 */
export function CheckoutLayout() {
  const { clientType } = useQueryParamsContext();
  
  // Determine which checkout component to render (case-insensitive check)
  const normalizedClientType = clientType?.toUpperCase();
  const isMSC = normalizedClientType === 'MSC';
  
  return (
    <div style={{ width: '100%', boxSizing: 'border-box', fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ width: '100%', margin: 0, padding: 0 }}>
        {isMSC ? <EckohCheckout /> : <MicroformFlex />}
      </div>
    </div>
  );
}
